import {
    Baby,
    Bike,
    Book,
    Briefcase,
    Car,
    Headphones,
    Home,
    Monitor,
    Music,
    PawPrint,
    Shirt,
    Smartphone,
    Sofa,
    Truck,
    Wrench,
} from 'lucide-react';
import { getCategoriesForHome } from '../../data/categories';
import './CategoryGrid.css';

const ICON_MAP = {
  cars: Car,
  bikes: Bike,
  motorcycles: Bike,
  'mobile-phones': Smartphone,
  mobiles: Smartphone,
  vehicles: Car,
  properties: Home,
  property: Home,
  'electronics-appliances': Monitor,
  electronics: Monitor,
  'commercial-vehicles-spares': Truck,
  jobs: Briefcase,
  furniture: Sofa,
  'home-garden': Sofa,
  fashion: Shirt,
  pets: PawPrint,
  'books-sports-hobbies': Book,
  services: Headphones,
  kids: Baby,
  'tools-machinery': Wrench,
  'music-instruments': Music,
  rent: Home,
  commercial: Truck,
  scooters: Bike,
  houses: Home,
};

function CategoryGrid({ onSelectCategory }) {
  const categories = getCategoriesForHome();

  const handleClick = (name, id) => {
    if (onSelectCategory) {
      onSelectCategory(name, id);
    }
  };

  return (
    <div className="categoryGridWrapper">
      <div className="categoryGridStrip">
        <div className="categoryGridScroll">
          {categories.map((cat) => {
            const IconComponent = ICON_MAP[cat.id] || Home;
            return (
              <button
                type="button"
                key={cat.id}
                className="categoryGridItem"
                onClick={() => handleClick(cat.name, cat.id)}
              >
                <div
                  className={`categoryGridIcon categoryIcon_${cat.id}`}
                >
                  <IconComponent size={24} strokeWidth={1.5} className="catLucideIcon" />
                </div>
                <span className="categoryGridName">{cat.name}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default CategoryGrid;
